import { render, staticRenderFns } from "./OrderStatuses.vue?vue&type=template&id=881b9e56&scoped=true"
import script from "./OrderStatuses.vue?vue&type=script&lang=js"
export * from "./OrderStatuses.vue?vue&type=script&lang=js"
import style0 from "./OrderStatuses.vue?vue&type=style&index=0&id=881b9e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881b9e56",
  null
  
)

export default component.exports